"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgListIcon = function SvgListIcon(_ref) {
  var theme = _ref.theme,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ["theme", "variant"]);

  var background = theme.name === 'legacy' ? theme.colors.neutral['300'] : theme.colors.primary.lightest;
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 13.6a9.6 9.6 0 01-9.6 9.6 9.6 9.6 0 01-9.6-9.6A9.6 9.6 0 0110.4 4c5.302 0 9.6 4.298 9.6 9.6z",
      fill: variant === 'light' ? '#CCEFF1' : background
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "ListIcon_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 2,
      y: 0,
      width: 22,
      height: 22,
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.4.8h20.8v20.8H2.4V.8z",
        fill: "#fff"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#ListIcon_svg__a)",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8 2.4C7.948 2.4 4 6.348 4 11.2S7.948 20 12.8 20s8.8-3.948 8.8-8.8-3.948-8.8-8.8-8.8zm0 19.2c-5.734 0-10.4-4.666-10.4-10.4C2.4 5.465 7.066.8 12.8.8c5.735 0 10.4 4.665 10.4 10.4 0 5.734-4.665 10.4-10.4 10.4z",
        fill: variant === 'light' ? '#00AEB8' : theme.colors.primary.main
      })
    })]
  }));
};

var _default = SvgListIcon;
exports["default"] = _default;